export const locale = {
  lang: 'zh1',
  data: {
    'PORTAL': {
      'BTN_SCREE_SHO':'截圖',
      'TOTALCOLA':'僱員總數',
      'TOTALFAL':'尚未回應的員工',
      'TOTALCONT':'已經回复的員工',
      'TOTALPRO':'總進度',
      'TOTALLOG':'尚未完成調查的員工',
      'REPORTE':'建議的回應數量...',
      'RANKING':'的最低迴應數...',
      'TOOLT_REPORTE':'通過人口統計學截止點提供統計上有意義的結果的建議響應次數',
      'TOOLT_RANKING':'公司認證/排名的最低迴應數',

      'REPORTE_CER_CARCA':'建議的回複數...',
      'TOOLT_REPORTE_CER_CARCA':'考慮到每個選項將獲得 5 個回复',
      'RANKING_CER_CARCA':'最少回複數...',
      'TOOLT_RANKING_CER_CARCA':'組織認證/排名的最低響應數',

      'REPORTE_MED_CARCA':'建議的回複數...',
      'TOOLT_REPORTE_MED_CARCA':'考慮到每個選項將獲得 5 個回复',
      'RANKING_MED_CARCA':'最少回複數...',
      'TOOLT_RANKING_MED_CARCA':'組織認證/排名的最低響應數',

      'TOTALMIN':'最低員工人數',
      'SELECTFPLA':'過濾器',
      'TBARRAPROGRESO':'當前進度',
      'ACCESODENEGADO':'訪問鏈接已過期',
      'ACCESOMSJPRE_1': '調查的截止日期已到，此門戶網站仍將有效 ',
      'ACCESOMSJPRE_2': ' 天。',
      'BTNOK': '好的',
      'DIARESTA':'剩餘的日子',
      'NO-INFO':'協作者數據庫中缺少的信息',
      'COLAB':'僱員',
      'PORTAL_V1':'計數門戶 V1',
      'PORTAL_V2':'計數門戶 V2',
      'DI-TRANSCU':'天過去了',
      'ETI_GRAFI_ZONA_HO': '圖中顯示的日期設置為本地時間: ',
      'ETI_FILT_V1&V2': '標有（*）的組不顯示信息，因為它們沒有顯示進度所需的最小用戶數 ',
      'WAR_RESU_ARE_MIN5': '每個區域顯示結果的最小響應數為5',
      'FILTROS':{
        '1': '國家',
        '2': '位置',
        '3': '區域-部門',
        '4': '學歷',
        '5': '部門',
        '6': '部門',
         '7': '地理級別 1',
         '8': '地理級別 2',
         '9': '地理級別 3',
         '10': '地理等級 4',
         '11':'結構級別 1',
         '12': '結構級別 2',
         '13': '結構級別 3',
         '14': '地理級別 8',
         '15': '地理等級9',
         '16': '地理級別 10',
         '17': '等級 1',
         '18': '等級 2',
         '19': '等級 3',
         '20': '層級 4',
         '21': '等級 5',
         '22': '層級 6',
         '23': '層級 7',
         '24': '層級 8',
         '25': '等級 9',
         '26': '等級 10',
      },
      'COLUMNAS_TABLA':{
        'NIVEL1': '1 級',
        'NIVEL2': '2 級',
        'DEMOGRAFICO': '人口統計',
        'SEGMENTO': '分割',
        'COLABORADORES_T': '合作者總數',
        'PENDIENTES_RESPONDER': '尚未回應的協作者',
        'YA_RESPONDIERON': '已經回應的協作者',
        'AVANCE': '預習',
        'FILTERS': '篩選器'
      },
      'EXCEL_V2':{
        'TITULO_AVANCE': '實施調查的進展情況: ',
        'SHEET': '報告',
        'DESCARGA': '的計數門戶 ',
        'MODAL_DESCARGA': '正確下載'
      },
      'ETIQUETAS':{
        'ETIQUETAS': '每頁項目',
        'OF': '從',
        'BOTON':'重新啟動過濾器'
      },
      'FILTROS_V2':{
        'ninguno': '沒有',
        'Company': '公司',
        'country': '國家',
        'location': '位置',
        'area': '區',
        'antiquity': '資歷',
        'generation': '代',
        'charge': '位置',
        'homologado': '職位批准',
        'gender': '性別',
        'typeofwork': '什麼樣的工作',
        'workCondition': '工作環境',
        'academico': '學位',
        'contratacion': '合同類型',
        'personal': '人員類型',
        'geo_1': '地理等級1',
        'geo_uno': '地理等級1',
        'geo_2': '地理等級2',
        'geo_3': '地理級別3',
        'geo_4': '地理等級4',
        'geo_5': '地理等級5',
        'geo_6': '地理6級',
        'geo_7': '地理7級',
        'geo_8': '地理位置8級',
        'geo_9': '地理9級',
        'geo_10': '地理10級',
        'structure_1': '結構一級',
        'structure_2': '結構等級2',
        'structure_3': '結構等級3',
        'structure_4': '結構等級4',
        'structure_5': '結構等級5',
        'structure_6': '結構等級6',
        'structure_7': '結構等級7',
        'structure_8': '結構等級8',
        'structure_9': '結構層9',
        'structure_10': '結構層10',
        //////CLAVES PARA PORTAL DE CONTEOS///
        'structure_uno': '結構一級',
        'structure_DOS': '結構等級2',
        'structure_TRES': '結構等級3',
        'structure_CUATRO': '結構等級4',
        'structure_CINCO': '結構等級5',
        'structure_SEIS': '結構等級6',
        'structure_SIETE': '結構等級7',
        'structure_OCHO': '結構等級8',
        'structure_NUEVE': '結構層9',
        'structure_DIEZ': '結構層10',
        'bUnit': '事業部',
      },
      'FILTROS_V2_HK':{
        'ninguno': '沒有',
        'Company': '公司',
        'country': '國家',
        'location': '工作地點',
        'area': '部門',
        'antiquity': '資歷',
        'generation': '代',
        'charge': '工作職位或職能',
        'homologado': '職位批准',
        'gender': '性別',
        'typeofwork': '工作狀態',
        'workCondition': '工作環境',
        'academico': '學歷',
        'contratacion': '合同類型',
        'personal': '人員類型',
        'geo_1': '地理等級1',
        'geo_uno': '地理等級1',
        'geo_2': '地理等級2',
        'geo_3': '地理級別3',
        'geo_4': '地理等級4',
        'geo_5': '地理等級5',
        'geo_6': '地理6級',
        'geo_7': '地理7級',
        'geo_8': '地理位置8級',
        'geo_9': '地理9級',
        'geo_10': '地理10級',
        'structure_1': '結構一級',
        'structure_2': '結構等級2',
        'structure_3': '結構等級3',
        'structure_4': '結構等級4',
        'structure_5': '結構等級5',
        'structure_6': '結構等級6',
        'structure_7': '結構等級7',
        'structure_8': '結構等級8',
        'structure_9': '結構層9',
        'structure_10': '結構層10',
        //////CLAVES PARA PORTAL DE CONTEOS///
        'structure_uno': '結構一級',
        'structure_DOS': '結構等級2',
        'structure_TRES': '結構等級3',
        'structure_CUATRO': '結構等級4',
        'structure_CINCO': '結構等級5',
        'structure_SEIS': '結構等級6',
        'structure_SIETE': '結構等級7',
        'structure_OCHO': '結構等級8',
        'structure_NUEVE': '結構層9',
        'structure_DIEZ': '結構層10',
        'bUnit': '事業部',
      },
      'PRODUCTO':{
        'CERT':'Certificar',
        'MED':'Medir',
        'NOM35':'Norma 035',
        'PULSE':'Pulsecheck',
        'FOCUS':'Focus Area',
        'MEDIR_1': '增強測量',
        'MEDIR_2': '測量+ MST',
        'MEDIR_3': '按區域測量',
        'MEDIR_4': '領導測量',
        'MEDIR_5': '按尺寸測量',
        'MEDIR_6': '認證措施',
        'NAME':    '公司: ',
        'PRODUCTO':'產品： ',
        'PORTAL':'計數門戶 ',
        'LEADER_GO':'Leader Go',
        'AMCO':'AMCO',
        'TRAB_DIGN':'體面的工作',
        'PRI_EMPLE':'第一份工作',
      },
      'EXCEL':{
        'NOMBOTON': '匯出Excel',
        'NOMBOTONREDUCIDO': '出口到Excel減少',
        'NOMEMPRE':'NOMBRE EMPRESA:',
        'NOMUSUARIO':'NOMBRE USUARIO:',
        'NOMPROD':'NOMBRE PRODUCTO:',
        'FECHLANZA':'FECHA LANZAMIENTO:',
        'FECHDESCA':'FECHA DE DESCARGA:',
        'DRESTAN':'DIA RESTANTES:',
        'TOTALCOLA':'TOTAL DE COLABORADORES:',
        'TOTALFAL': 'COLABORADORES QUE AUN NO RESPONDEN:',
        'TOTALCONT':'COLABORADORES QUE YA RESPONDIERON:',
        'TOTALPRO': 'PROGRESO TOTAL:',
        'REPORTE':'INDICE DE RESPUESTA PARA ENTREGABLES:',
        'RANKING':'MUESTRA PARA CERTIFICACION Y RANKING:',
        'FILT':'FILTRO:',
        'NOMFILT':'NOMBRE FILTRO:',
        //pestaña principal
        'INFOGENE': 'Informe general',
        'FILTROSNAME':{
          'country':'país',
          'location':'ubicación',
          'area':'área',
          'antiquity':'antigüedad',
          'generation':'generación',
          'charge':'carga',
          'homologado':'homologado',
          'gender':'género',
          'typeofwork':'tipo de trabajo',
          'workCondition':'Condición de trabajo',
          'academico':'académico',
          'contratacion':'Contratación',
          'personal':'personal',
          'geo_1':'geo_1',
          'geo_2':'geo_2',
          'geo_3':'geo_3',
          'geo_4':'geo_4',
          'geo_5':'geo_5',
          'structure_1':'estructura_1',
          'structure_2':'estructura_2',
          'structure_3':'estructura_3',
          'structure_4':'estructura_4',
          'structure_5':'estructura_5',
          'structure_6':'estructura_6',
          'structure_7':'estructura_7',
          'structure_8':'estructura_8',
          'structure_9':'estructura_9',
          'structure_10':'estructura_10',
        }

      },
      'TIPO-PERSONAL':{
        'TIPO':'個人類型',
        '1':'辛迪加',
        '2':'信任',
        '3':'都',
      }

    },
    'PORTAL35': {
      'TOTALCOLA':'員工總數',
      'TOTALFAL': '還沒有回复的員工',
      'TOTALCONT':'已經回复的員工',
      'TOTALPRO': '樣本',
      'SELECTFPLA': '工作中心',
      'TBARRAPROGRESO':'總進度',
      'TOTALLOG':'未完成調查的員工',
      'TOTALGONE':'決定不回答的人',
      'FILTROS':{
        '1': "工作中心",
        '2': '國家',
        '3': '位置',
        '4': '面積',
        '5': '學歷',
        '6': '部門',
        '7': '地理級別 1',
        '8': '地理級別 2',
        '9': '地理級別 3',
        '10': '地理等級 4',
        '11': '地理等級 5',
        '12': '地理等級 6',
        '13': '地理級別 7',
        '14': '地理級別 8',
        '15': '地理等級9',
        '16': '地理級別 10',
        '17': '等級 1',
        '18': '等級 2',
        '19': '等級 3',
        '20': '層級 4',
        '21': '等級 5',
        '22': '層級 6',
        '23': '層級 7',
        '24': '層級 8',
        '25': '等級 9',
        '26': '等級 10',
      }

    },
    'BTN':{
      'USERS':'合作者'
    }
  }
};
